'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _globals = require('../mixins/globals');

var _globals2 = _interopRequireDefault(_globals);

var _UiAlert = require('../material/UiAlert.vue');

var _UiAlert2 = _interopRequireDefault(_UiAlert);

var _UiIconButton = require('../material/UiIconButton.vue');

var _UiIconButton2 = _interopRequireDefault(_UiIconButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'ListarUsuario',
  mixins: [_globals2.default],
  components: {
    UiAlert: _UiAlert2.default,
    UiIconButton: _UiIconButton2.default
  },
  data: function data() {
    return {
      currentUser: {},
      userRoles: [{ text: 'admin', value: 1 }, { text: 'gerente', value: 2 }, { text: 'subgerente', value: 3 }],
      users: [],
      error: {
        status: false,
        messages: ''
      },
      responseUsers: false,
      flagDelete: false,
      disabledCreate: false,
      disabledDelete: false,
      loadingDelete: false,
      typeItem: '',
      itemDelete: {
        name: '',
        id: 0
      }
    };
  },

  computed: {
    disabledCreate: function disabledCreate() {
      if (window.localStorage.getItem('role') == 'subgerente') {
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {
    'error.status': function errorStatus(val, old) {
      var _this = this;

      if (val) {
        setTimeout(function () {
          _this.error.status = false;
        }, 1600);
      }
    }
  },
  created: function created() {
    this.fetchUsers();
    this.fetchUser();
  },


  methods: {
    fetchUser: function fetchUser() {
      var _this2 = this;

      var _url = '/admin/users/' + this.uid;

      this.$http({
        url: _url,
        method: 'GET'
      }).then(function (response) {
        _this2.currentUser = response.data;
      }, function (response) {
        if (response.status === 401 || response.status === 403) {
          window.localStorage.removeItem('restaurante');
          window.localStorage.removeItem('local');
          window.localStorage.removeItem('role');
          window.localStorage.removeItem('uid');
          _this2.$router.go({
            name: 'sign'
          });
        }
      });
    },
    getRole: function getRole(local, restaurante) {
      if (local == 0) {
        if (restaurante == 0) {
          return "admin";
        } else {
          return "gerente";
        }
      } else {
        return "subgerente";
      }
    },
    disablePermission: function disablePermission(role, restaurante) {
      var currentUserRoleObj = this.userRoles.filter(function (val) {
        return val.text == window.localStorage.getItem('role');
      });
      var cURole = currentUserRoleObj[0].value;
      var evalUserRoleObj = this.userRoles.filter(function (val) {
        return val.text == role;
      });
      var eURole = evalUserRoleObj[0].value;
      if (currentUserRoleObj[0].text === 'admin') {
        return false;
      } else {
        if (cURole < eURole) {
          if (this.currentUser.restaurante_id == restaurante) {
            return false;
          } else {
            return true;
          }
          return false;
        } else {
          return true;
        }
      }
    },
    opentDeleteModal: function opentDeleteModal(_item, _type) {
      this.flagDelete = !this.flagDelete;
      this.typeItem = _type;
      this.itemDelete.name = _item.name;
      this.itemDelete.id = _item.id;
    },
    onSubmitDelete: function onSubmitDelete() {
      var _this3 = this;

      var _url = '/admin/users/delete';

      this.disabledDelete = true;
      this.loadingDelete = true;
      var _temp = {
        id: this.itemDelete.id
      };
      this.$http.post(_url, _temp).then(function (response) {
        _this3.restoreItem(_this3.itemDelete.id, 'delete');
        _this3.disabledDelete = false;
        _this3.loadingDelete = false;
        _this3.flagDelete = !_this3.flagDelete;
      }, function (response) {
        _this3.disabledDelete = false;
        _this3.loadingDelete = false;
        _this3.flagDelete = !_this3.flagDelete;
      });
    },
    onSubmitRestore: function onSubmitRestore() {
      var _this4 = this;

      var _url = '/admin/users/restore';

      this.disabledDelete = true;
      this.loadingDelete = true;
      var _temp = {
        id: this.itemDelete.id
      };
      this.$http.post(_url, _temp).then(function (response) {
        _this4.restoreItem(_this4.itemDelete.id);
        _this4.disabledDelete = false;
        _this4.loadingDelete = false;
        _this4.flagDelete = !_this4.flagDelete;
      }, function (response) {
        _this4.disabledDelete = false;
        _this4.loadingDelete = false;
        _this4.flagDelete = !_this4.flagDelete;
      });
    },
    fetchUsers: function fetchUsers() {
      var _this5 = this;

      var _url = '/admin/users';
      this.$http({
        url: _url,
        method: 'GET'
      }).then(function (response) {
        var _data = response.data;
        _this5.users = _data;
        // let _data = response.data
        _this5.$nextTick(function () {
          _this5.responseUsers = true;
        });
      }, function (response) {
        if (response.status === 401 || response.status === 403) {
          window.localStorage.removeItem('restaurante');
          window.localStorage.removeItem('local');
          window.localStorage.removeItem('role');
          window.localStorage.removeItem('uid');
          _this5.$router.go({
            name: 'sign'
          });
        }
      });
    },
    restoreItem: function restoreItem(_uid) {
      var _type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'restore';

      var _p = this.users;
      _p.forEach(function (val) {
        if (val.id === _uid) {
          if (_type === 'delete') {
            val.deleted_at = 'restore';
          } else {
            val.deleted_at = null;
          }
          return;
        }
      });
    }
  }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"bgTransition\">\n  <template v-if=\"!responseUsers\">\n    <div class=\"preload-app\">\n      <ui-progress-linear :show=\"!responseUsers\" color=\"black\"></ui-progress-linear>\n    </div>\n  </template>\n  <template v-else=\"\">\n    <div class=\"header-section h_contact\">\n      <h2 v-if=\"titleShow\" transition=\"slideLeft\">Lista de Usuarios</h2>\n      <div v-if=\"titleShow\" transition=\"slideRight\" class=\"buttons-options\">\n        <ui-button color=\"lanacional-white\" raised=\"\" @click=\"backToUrl('usuario-crear')\" :disabled=\"disabledCreate\">Crear Usuario</ui-button>\n      </div>\n    </div>\n\n    <section class=\"section-users\">\n      <template v-if=\"users.length == 0\">\n        <ui-alert :dismissible=\"false\">No hay usuarios registrados.</ui-alert>\n      </template>\n      <template v-else=\"\">\n        <div class=\"width-users clearfix table-responsive\">\n          <table class=\"table table-striped table-bordered\" style=\"margin: 0\">\n            <thead>\n              <tr>\n                <th>Nombres</th>\n                <th>DNI</th>\n                <th>Rol</th>\n                <th>Correo</th>\n                <th>Usuario</th>\n                <th style=\"width: 82px;\">Opciones</th>\n              </tr>\n            </thead>\n            <tbody>\n              <template v-for=\"item of users\">\n                <tr>\n                  <td>{{item.name}}</td>\n                  <td>{{item.dni}}</td>\n                  <td>{{getRole(item.local_id,item.restaurante_id)}}</td>\n                  <td>{{item.email}}</td>\n                  <td>{{item.username}}</td>\n                  <td v-if=\"isDataNull(item.deleted_at)\">\n                    <ui-icon-button @click=\"backToUrl('usuario-editar', item.id+'')\" type=\"flat\" icon=\"edit\" color=\"lanacional-primario-text\" :disabled=\"disablePermission(getRole(item.local_id,item.restaurante_id),item.restaurante_id)\"></ui-icon-button>\n                    <ui-icon-button @click=\"opentDeleteModal(item,'delete')\" type=\"flat\" icon=\"delete\" color=\"lanacional-cuarto-text\" :disabled=\"disablePermission(getRole(item.local_id,item.restaurante_id),restaurante_id)\"></ui-icon-button>\n                  </td>\n                  <td v-if=\"!isDataNull(item.deleted_at)\" class=\"td-restore\">\n                    <ui-icon-button @click=\"opentDeleteModal(item, 'restore')\" type=\"flat\" icon=\"restore\" color=\"lanacional-primario-text\" :disabled=\"disablePermission(getRole(item.local_id,item.restaurante_id),restaurante_id)\"></ui-icon-button>\n                  </td>\n                </tr>\n              </template>\n            </tbody>\n          </table>\n        </div>\n      </template>\n    </section>\n\n    <div class=\"modal-mask\" v-if=\"flagDelete\" transition=\"modal\">\n      <div class=\"modal-wrapper\">\n        <div class=\"modal-container\">\n          <div class=\"modal-header\">\n            <h4 class=\"modal-title\">{{typeItem=='delete' ?'Deshabilitar Usuario':'Habilitar Usuario'}} </h4>\n          </div>\n          <div class=\"modal-body text-center\">\n            <p style=\"margin:0;\">¿Estás seguro que deseas {{typeItem=='delete' ?'deshabilitar':'habilitar'}} a <b>{{itemDelete.name}}</b>?</p>\n          </div>\n          <div class=\"modal-footer\">\n            <div class=\"text-center\">\n              <ul class=\"nav nav_menu_form\">\n                <li>\n                  <ui-button @click=\"flagDelete = !flagDelete\" text=\"Cancel\" color=\"lanacional-primario\" :disabled=\"disabledDelete\"></ui-button>\n                </li>\n                <li>\n                  <template v-if=\"typeItem=='delete'\">\n                    <ui-button @click=\"onSubmitDelete()\" text=\"Deshabilitar\" color=\"lanacional-cuarto\" :loading=\"loadingDelete\"></ui-button>\n                  </template>\n                  <template v-else=\"\">\n                    <ui-button @click=\"onSubmitRestore()\" text=\"Habilitar\" color=\"lanacional-cuarto\" :loading=\"loadingDelete\"></ui-button>\n                  </template>\n                </li>\n              </ul>\n            </div>\n          </div>\n\n        </div>\n      </div>\n    </div>\n  </template>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-9d5165f6", module.exports)
  } else {
    hotAPI.update("_v-9d5165f6", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}